import {
  addLoadingState as coreAddLoadingState,
  removeLoadingState as coreRemoveLoadingState,
  type LoadingStateOptions,
} from '@sg-core/resources/assets/js/helpers/buttons';

import type { ComponentPublicInstance } from 'vue';

type ButtonTarget = HTMLElement | ComponentPublicInstance;

export function addLoadingState(target: ButtonTarget, options: LoadingStateOptions = {}): void {
  coreAddLoadingState(target, {
    size: 'sm',
    text: 'Loading',
    ...options,
    type: 'circle',
  });
}

export const removeLoadingState = coreRemoveLoadingState;
